/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleMerchantPriceReportRowData } from './GoogleMerchantPriceReportRowData';
import {
    GoogleMerchantPriceReportRowDataFromJSON,
    GoogleMerchantPriceReportRowDataFromJSONTyped,
    GoogleMerchantPriceReportRowDataToJSON,
    GoogleMerchantPriceReportRowDataToJSONTyped,
} from './GoogleMerchantPriceReportRowData';

/**
 * 
 * @export
 * @interface GoogleMerchantPriceReportData
 */
export interface GoogleMerchantPriceReportData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportData
     */
    competitivenessPublishedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportData
     */
    insightsPublishedAt?: string | null;
    /**
     * 
     * @type {Array<GoogleMerchantPriceReportRowData>}
     * @memberof GoogleMerchantPriceReportData
     */
    rows?: Array<GoogleMerchantPriceReportRowData>;
}

/**
 * Check if a given object implements the GoogleMerchantPriceReportData interface.
 */
export function instanceOfGoogleMerchantPriceReportData(value: object): value is GoogleMerchantPriceReportData {
    return true;
}

export function GoogleMerchantPriceReportDataFromJSON(json: any): GoogleMerchantPriceReportData {
    return GoogleMerchantPriceReportDataFromJSONTyped(json, false);
}

export function GoogleMerchantPriceReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantPriceReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'competitivenessPublishedAt': json['competitivenessPublishedAt'] === undefined ? undefined : json['competitivenessPublishedAt'] === null ? null : json['competitivenessPublishedAt'],
        'insightsPublishedAt': json['insightsPublishedAt'] === undefined ? undefined : json['insightsPublishedAt'] === null ? null : json['insightsPublishedAt'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleMerchantPriceReportRowDataFromJSON)),
    };
}

export function GoogleMerchantPriceReportDataToJSON(json: any): GoogleMerchantPriceReportData {
    return GoogleMerchantPriceReportDataToJSONTyped(json, false);
}

export function GoogleMerchantPriceReportDataToJSONTyped(value?: GoogleMerchantPriceReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitivenessPublishedAt': value['competitivenessPublishedAt'],
        'insightsPublishedAt': value['insightsPublishedAt'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleMerchantPriceReportRowDataToJSON)),
    };
}

